import React from 'react';
import { Button, Dialog, DialogActions } from '@mui/material';

import { closeTransformMenu } from '../../store/slices/panelDataSlice';
import { useAppDispatch, useAppSelector } from '../hooks';
import TransformTool from './TransformTool';

const TransformMenu = () => {
  const displayState = useAppSelector((state) => state.panelData.transformMenuState);

  const dispatch = useAppDispatch();

  if (!displayState.isOpen) {
    return null;
  }
  return (
    <Dialog onClose={() => dispatch(closeTransformMenu())} onMouseUp={(e) => e.stopPropagation()} open>
      <TransformTool
        showCoordinateOptions={displayState.includesCoordinateOptions}
        onFinalize={() => dispatch(closeTransformMenu())}
      />
      <DialogActions>
        <Button variant="contained" onClick={() => dispatch(closeTransformMenu())}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransformMenu;
